import { LightColors } from '@vfgroup-oneplatform/foundation/Components/Themes/Modes/Light/Colors'
import { Colors } from '@vfgroup-oneplatform/foundation/Components/Themes'

export default {
  ...LightColors,
  divider: Colors.white,
  tintColor: Colors.ocean,
  progressError: Colors.vfRed,
  disabled: Colors.very_light_grey,
}
